import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, EventEmitter, Output, ViewChild, TemplateRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { Divisa } from "src/app/models/Divisa";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { ReferenciaDteEmitido } from "src/app/models/Dte/ReferenciaDteEmitido";
import { TipoReferenciaEnum } from "src/app/models/Dte//TipoReferencia.enum";
import { TipoDte } from "src/app/models/tipoDte";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TipoDocumentoReferencia } from "src/app/models/TipoDocRef";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { MonedaAduana } from "src/app/models/MonedaAduana";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { EmisorService } from "src/app/services/emisor.service";
import { ReferencesListComponent } from "./references-list/references-list.component";
import { PermissionService } from "src/app/services/permission.service";
import { PaykuService } from "src/app/services/payku.service";
import { take } from "rxjs/operators";
import { esTipoCambioValido, obtenerCotizacion } from "../dte-currency/dte-currency";

type FormGroupAttach = [string, FormGroup];
@Component({
	selector: "app-opciones-referencias-dte",
	templateUrl: "./opciones-referencias-dte.component.html",
	styleUrls: ["./opciones-referencias-dte.component.scss"],
})
export class OpcionesReferenciasDteComponent implements OnInit, OnChanges, OnDestroy {
	public haveDteReference: boolean = true;
	@ViewChild(ReferencesListComponent)
	private referencesListComponent: ReferencesListComponent;
	@Input() public fromExistente: DteEmitido;
	@Input() public cargandoDivisas = false;
	@Input() public errorDivisas = false;
	@Output() public reintentarDivisas = new EventEmitter<void>();
	private valorDivisaManual = false;
	public dteReference: ReferenciaDteEmitido = new ReferenciaDteEmitido();
	public tipoDteSource: TipoDocumentoReferencia[];
	public tipoReferenciaEnumSource: any[];
	private optionsReference: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
	@Output() referencesListEmitter: EventEmitter<ReferenciaDteEmitido[]> = new EventEmitter<ReferenciaDteEmitido[]>();
	public optionsReferenceFormGroup: FormGroup;
	@ViewChild("ivaCheckboxTemplate") ivaCheckboxTemplate: TemplateRef<any>;
	@ViewChild("dtePagadoTemplate") dtePagadoTemplate: TemplateRef<any>;
	@ViewChild("monedaTemplate") monedaTemplate: TemplateRef<any>;
	public eferenceDteFormGroup: FormGroup;
	public divisasValueFormGroup: FormGroup;
	public divisasList: Divisa[] = [];
	private divisasObservable$: Observable<Divisa[]>;
	public resetingDte$: Observable<boolean>;
	public invoiceType$: Observable<InvoiceType>;
	public showingCurrencyOptions: boolean = true;
	private subscriptions: Subscription[] = [];
	public detailWithTax$: Observable<boolean>;
	public selectedForeignCurrency: boolean = false;
	public currentInvoiceType: InvoiceType;
	private referencesList: ReferenciaDteEmitido[] = [];
	public currentReferencesList: ReferenciaDteEmitido[] = [];
	public monedasAduanaSource: MonedaAduana[] = [];
	private refFromGuides$: Observable<ReferenciaDteEmitido[]>;
	private restoringFromDraft: boolean = false;
	private updatingFromThisComponent: boolean = false;

	public showGlobalRefCheckbox: boolean = false;
	public disableCLPOption: boolean = false;
	public emisorId: string;
	public showDtePagadoButton: boolean = false;
	public canShowDtePagado = false;
	tiposDteHabilitados: number[] = [];

	constructor(private ref: ChangeDetectorRef, private localStorage: LocalStorageService, private builder: FormBuilder, private facturador: FacturacionIndividualService,public tokenService: TokenStorageService, private emisorService: EmisorService,public permissions: PermissionService,private paykuService: PaykuService) {
		this.emisorId = this.tokenService.getCompany();
		this.divisasObservable$ = this.facturador.divisasListObservable;
		this.resetingDte$ = this.facturador.submittedDteObservable;
		this.invoiceType$ = this.facturador.currentInvoiceTypeObservable;
		this.detailWithTax$ = this.facturador.detailWithTaxInOptionsObservable;
		this.monedasAduanaSource = this.localStorage.getMonedaAduanas();
		this.refFromGuides$ = this.facturador.referencesListFromGuidesObservable;
	}
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["fromExistente"] && changes["fromExistente"].currentValue) {
			const dteExistente = changes["fromExistente"].currentValue as DteEmitido;
			if (dteExistente != null) {
				this.optionsReference.sonDetallesConIVA = false;
				this.optionsReferenceFormGroup.controls.detallesExentos.patchValue(false);
				this.onSubmit(false);
				// Emitir el dteId al padre
				this.referencesListEmitter.emit(this.referencesList);
			}
		}
	}

	ngOnInit(): void {
		 this.validatePaykuAdicional();
		 this.cargarTiposDteHabilitados();
		this.tipoDteSource = JSON.parse(this.localStorage.getTipoDocReferencias()) as TipoDocumentoReferencia[];
		this.tipoReferenciaEnumSource = Object.keys(TipoReferenciaEnum).map((key) => ({
			key,
			name: TipoReferenciaEnum[key],
		}));
		this.tipoReferenciaEnumSource = this.tipoReferenciaEnumSource.splice(0, 3);
		this.tipoDteSource = [...this.tipoDteSource.filter((value, index, array) => array.findIndex((type) => type.codigo === value.codigo) === index)];
		this.createDivisasValueForm();
		this.createOptionsReferenceForm();
		this.recalcDtePagadoAvailability();
		const divisasSubscription = this.divisasObservable$.subscribe((list) => {
			this.divisasList = (list || []).filter((divisa) => divisa != null);
			if (this.selectedForeignCurrency && !this.valorDivisaManual) {
				this.onSubmit(false);
			}
			this.ref.detectChanges();
		});
		const invoiceTypeSubscription = this.invoiceType$.subscribe((res) => {
			this.modificationsByInvoiceType(res);
		});
		this.changeReference();
		//this.optionsReferenceFormGroup.get('referenciaDte').disable();

		const resetSubscription = this.resetingDte$.subscribe((res) => {
			if (res) {
				this.valorDivisaManual = false;
				this.currentReferencesList = [];
				this.optionsReference.listaReferencias = undefined;
				this.optionsReferenceFormGroup.patchValue({
					haveDteReference: this.requiereReferencia,
					dteReferenceList: [],
					tipoMoneda: this.currentInvoiceType == InvoiceType.FacturaExportacion ? "USD" : "CLP",
				}, { emitEvent: false });
				this.onSubmit(false);
			}
		});

		const guideRefSubscription = this.refFromGuides$.subscribe((res) => {
			if (res.length > 0) {
				this.optionsReferenceFormGroup.controls.haveDteReference.patchValue(true);
				this.optionsReferenceFormGroup.controls.detallesExentos.patchValue(false);
				this.changeReference();
				this.addGlobalRefCheckbox();
				this.showGlobalRefCheckbox = true;
			} else {
				this.showGlobalRefCheckbox = false;
				if (this.optionsReferenceFormGroup.controls.refGlobal) {
					this.optionsReferenceFormGroup.removeControl("refGlobal");
				}
			}
		});
		this.optionsReference.dtePagado = this.showDtePagadoButton ? false : null;
		this.onSubmit(false);
		const optionsStateSubscription = this.facturador.opcionesReferenciaObservable.subscribe((state) => {
			this.applyOptionsFromService(state);
		});
		if (invoiceTypeSubscription) {
			this.subscriptions.push(invoiceTypeSubscription);
		}
		this.subscriptions.push(resetSubscription);
		this.subscriptions.push(divisasSubscription);
		this.subscriptions.push(guideRefSubscription);
		this.subscriptions.push(optionsStateSubscription);
		//this.subscriptions.push(detailWithTaxSubscription);
		this.emisorService.getDetallesIvaIncluido(this.emisorId).subscribe({
			next: (resp) => {
				const valor = resp.data;
				this.optionsReferenceFormGroup.patchValue({ detallesExentos: valor });
				this.optionsReference.sonDetallesConIVA = valor;
				this.changeReference();
			},
			error: (err) => console.error("Error al obtener IVA Incluido", err),
		});
	}
	private validatePaykuAdicional(): void {
		if (!this.emisorId) {
			this.showDtePagadoButton = false;
			this.recalcDtePagadoAvailability();
			return;
		}
		this.paykuService.validarAdicionalPaykuPorEmisor(this.emisorId).subscribe({
			next: (response) => {
			this.showDtePagadoButton = response.data?.habilitado || false;
			this.recalcDtePagadoAvailability();
			this.ref.detectChanges();
			},
			error: (error) => {
			console.error('Error validando Payku adicional:', error);
			this.showDtePagadoButton = false;
			this.recalcDtePagadoAvailability();
			this.ref.detectChanges();
			}
		});
	}
	onTipoMonedaChange(tipo: string): void {
		this.valorDivisaManual = false;
		this.optionsReferenceFormGroup.controls.tipoMoneda.setValue(tipo, { emitEvent: false });
		this.selectedForeignCurrency = tipo === "USD" || tipo === "UF" || tipo === "OTHER";
		this.onSubmit(false);
	}

	changeReference() {
		this.updateReferenceValidators(this.optionsReferenceFormGroup.controls.haveDteReference.value);
		this.onSubmit(false);
	}

	changeGlobalReference() {
		this.changeReference();
	}
	changeDetallesConIVA(event) {
		this.optionsReference.sonDetallesConIVA = event.target.checked;
		this.ref.detectChanges();
		this.recalcDtePagadoAvailability();
		
		this.onSubmit(false);
	}

	changeDtePagado(event) {
		const canUseDtePagado = this.showDtePagadoButton && this.canShowDtePagado;
		this.optionsReference.dtePagado = canUseDtePagado ? event.target.checked : null;
		this.onSubmit(false);
	}
	private cargarTiposDteHabilitados(): void {
		if (this.emisorId) {
		this.paykuService.obtenerTiposDteHabilitados(this.emisorId).subscribe({
			next: (response) => {
			this.tiposDteHabilitados = response.data || [];
			this.recalcDtePagadoAvailability();
			this.ref.detectChanges();
			},
			error: (error) => {
			console.error('Error obteniendo tipos DTE habilitados:', error);
			this.tiposDteHabilitados = [];
			}
		});
		}
	}

	private getCodigoDteEspecifico(): number | null {
		const esExento = this.isExento();
		
		switch (this.currentInvoiceType) {
			case InvoiceType.Factura:
				return esExento ? 34 : 33;
			case InvoiceType.Boleta:
				return esExento ? 41 : 39;
			default:
				return null;
		}
	}

	
	private isExento(): boolean {
		try {
			let detalles: any[] = [];
			this.facturador.detalleDteListObservable.pipe(take(1)).subscribe(lista => {
				detalles = Array.isArray(lista) ? lista : [];
			});
			
			if (!detalles || detalles.length === 0) {
				return this.optionsReferenceFormGroup?.get('detallesExentos')?.value === false;
			}
		
			const itemsExentos = detalles.filter(d => d.esExento === true).length;
			const itemsNoExentos = detalles.filter(d => d.esExento === false).length;

			return itemsExentos > itemsNoExentos;
		} catch (error) {
			return this.optionsReferenceFormGroup?.get('detallesExentos')?.value === false;
		}
	}
	createOptionsReferenceForm() {
		this.optionsReferenceFormGroup = this.builder.group({
			haveDteReference: [false],
			tipoMoneda: [this.currentInvoiceType == InvoiceType.FacturaExportacion ? "USD" : "CLP"],
			tipoMonedaSelector: [this.monedasAduanaSource[0]],
			detallesExentos: [true],
			dtePagado: [{ value: null, disabled: true }],
			dteReferenceList: [],
			//referenciaDte:this.referenceDteFormGroup
		});
	}
	// updateDivisaValue(){
	//   var value = this.divisasValueFormGroup.controls.newValorDivisa.value;
	//   this.onSubmit(true);
	// }
	createDivisasValueForm() {
		this.divisasValueFormGroup = this.builder.group({
			newValorDivisa: [1, [Validators.required, (control) => esTipoCambioValido(control.value) ? null : { tipoCambio: true }]],
		});
	}

	onSubmit(updateDivisaValue: boolean) {
		if (this.restoringFromDraft) return;
		const controls = this.optionsReferenceFormGroup.controls;
		const tipoMoneda = controls.tipoMoneda.value;
		if (tipoMoneda !== this.optionsReference.tipoMoneda) this.valorDivisaManual = false;
		this.optionsReference.sonDetallesConIVA = controls.detallesExentos.value;
		this.optionsReference.haveDteReference = this.requiereReferencia || !!controls.haveDteReference.value;
		this.updateReferenceValidators(this.optionsReference.haveDteReference);
		this.optionsReference.tipoMoneda = tipoMoneda;
		this.selectedForeignCurrency = tipoMoneda !== "CLP";
		this.optionsReference.dtePagado = this.showDtePagadoButton && this.canShowDtePagado
			? (controls.dtePagado.value ?? false) : null;

		if (!this.selectedForeignCurrency) {
			this.valorDivisaManual = false;
			this.optionsReference.valorTipoMoneda = 1;
			this.optionsReference.tipoMonedaAduana = undefined;
			this.optionsReference.codigoMonedaAduana = undefined;
			controls.tipoMonedaSelector.patchValue(undefined, { emitEvent: false });
			this.divisasValueFormGroup.controls.newValorDivisa.patchValue(1, { emitEvent: false });
		} else if (updateDivisaValue) {
			this.valorDivisaManual = true;
			const valor = this.divisasValueFormGroup.controls.newValorDivisa.value;
			this.optionsReference.valorTipoMoneda = esTipoCambioValido(valor) ? Number(valor) : 0;
		} else if (!this.valorDivisaManual) {
			this.updateByForeignCurrency();
		}
		if (this.showGlobalRefCheckbox) {
			this.optionsReference.globalReferenceForGuideRefs = controls.refGlobal?.value === true;
		}
		// Editar la moneda no depende de completar las referencias. Estas siguen
		// siendo obligatorias en el formulario y se validan nuevamente al emitir.
		this.updatingFromThisComponent = true;
		try {
			this.facturador.updateOptionsReferences({ ...this.optionsReference });
		} finally {
			this.updatingFromThisComponent = false;
		}
	}

	get tipoCambioPendiente(): boolean {
		return this.selectedForeignCurrency && !esTipoCambioValido(this.optionsReference.valorTipoMoneda);
	}

	recargarDivisas(): void {
		if (this.tipoCambioPendiente) this.valorDivisaManual = false;
		this.reintentarDivisas.emit();
	}

	private get requiereReferencia(): boolean {
		return this.currentInvoiceType === InvoiceType.NotaCredito || this.currentInvoiceType === InvoiceType.NotaDebito;
	}

	changeDivisaPorSelector(event: MonedaAduana) {
		this.optionsReferenceFormGroup.controls.tipoMonedaSelector.patchValue(event, { emitEvent: false });
		this.valorDivisaManual = false;
		this.onSubmit(false);
	}

	detectChangeReferenceDate(event) {
		this.dteReference.fechaDteReferenciado = moment(event.startDate).toDate();
	}
	attachControls(parentFormGroup: FormGroup, childrenFormGroupToAttach: FormGroupAttach[]) {
		childrenFormGroupToAttach.forEach((st) => {
			parentFormGroup.addControl(st[0], st[1]);
			parentFormGroup.get(st[0]).enable();
		});
	}
	detachControls(parentFormGroup: FormGroup, childrenFormGroupToDetach: string[]) {
		childrenFormGroupToDetach.forEach((fg) => {
			parentFormGroup.removeControl(fg);
			parentFormGroup.get(fg).disable();
		});
	}

	detectChangetipoDte(event) {
		this.ref.detectChanges();
	}

	modificationsByInvoiceType(type: InvoiceType) {
		this.currentInvoiceType = type;
		switch (type) {
			case InvoiceType.Boleta: {
				this.showingCurrencyOptions = false;
				this.disableCLPOption = null;
				this.ref.detectChanges();
				break;
			}
			case InvoiceType.Factura: {
				this.showingCurrencyOptions = true;
				this.disableCLPOption = null;
				this.ref.detectChanges();
				break;
			}
			case InvoiceType.GuiaDespacho: {
				this.showingCurrencyOptions = true;
				this.disableCLPOption = null;
				this.ref.detectChanges();
				break;
			}
			case InvoiceType.NotaCredito: {
				this.optionsReferenceFormGroup.controls.haveDteReference.patchValue(true);
				this.changeReference();
				break;
			}
			case InvoiceType.NotaDebito: {
				this.optionsReferenceFormGroup.controls.haveDteReference.patchValue(true);
				this.changeReference();
				break;
			}

			case InvoiceType.LiquidacionFactura: {
				this.showingCurrencyOptions = false;
				this.disableCLPOption = null;
				this.ref.detectChanges();
				this.optionsReferenceFormGroup.controls.tipoMoneda.patchValue("CLP");
				this.onSubmit(false);
				break;
			}
			case InvoiceType.FacturaExportacion: {
				this.ref.detectChanges();
				this.valorDivisaManual = false;
				this.optionsReferenceFormGroup.controls.tipoMoneda.patchValue("USD");
				this.disableCLPOption = true;
				this.ref.detectChanges();
				this.onSubmit(false);
				break;
			}
			default: {
				this.disableCLPOption = null;
				this.ref.detectChanges();
			}
		}
		this.recalcDtePagadoAvailability();
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => {
			sub.unsubscribe();
		});
	}

	getMonedaAduanaOfTipoMonedaCheckBox(): MonedaAduana {
		let selected = this.optionsReferenceFormGroup.controls.tipoMoneda.value;
		let returnedMoneda: MonedaAduana;
		if (selected == "USD") {
			returnedMoneda = this.monedasAduanaSource.find((monAdu) => monAdu.nombre == "DÓLAR USA");
		}
		if (selected == "OTHER") {
			returnedMoneda = this.optionsReferenceFormGroup.controls.tipoMonedaSelector.value;
			if (!returnedMoneda) {
				returnedMoneda = this.monedasAduanaSource[0];
				this.optionsReferenceFormGroup.controls.tipoMonedaSelector.patchValue(returnedMoneda);
			}
		}
		return returnedMoneda;
	}

	updateByForeignCurrency() {
		const moneda = this.getMonedaAduanaOfTipoMonedaCheckBox();
		const tipo = this.optionsReference.tipoMoneda;
		const valor = tipo === "USD" || tipo === "UF"
			? obtenerCotizacion(this.divisasList, tipo)
			: moneda?.nombre?.trim().toUpperCase() === "EURO"
				? obtenerCotizacion(this.divisasList, "EUR")
				: moneda?.tipoCambio;
		// Cero representa una cotización pendiente; nunca inventamos una tasa de 1.
		this.optionsReference.valorTipoMoneda = esTipoCambioValido(valor) ? Number(valor) : 0;
		this.optionsReference.tipoMonedaAduana = moneda?.siglaDeclaracion;
		this.optionsReference.codigoMonedaAduana = moneda?.codigoAduana;
		this.divisasValueFormGroup.controls.newValorDivisa.patchValue(
			this.optionsReference.valorTipoMoneda || null, { emitEvent: false });
	}

	addGlobalRefCheckbox() {
		this.optionsReferenceFormGroup.addControl("refGlobal", new FormControl(false));
	}

	sincronizarReferencias(): void {
		this.referencesListComponent?.onSubmit();
	}

	getReferencesList(event: ReferenciaDteEmitido[]) {
		if (this.restoringFromDraft) {
			this.optionsReference.listaReferencias = event;
			this.currentReferencesList = event ?? [];
			this.optionsReferenceFormGroup.controls.dteReferenceList.patchValue(event, { emitEvent: false });
			return;
		}
		const referencias = event ?? [];
		this.optionsReference.listaReferencias = referencias.length ? referencias : undefined;
		this.optionsReferenceFormGroup.patchValue({
			haveDteReference: this.requiereReferencia || referencias.length > 0,
			dteReferenceList: referencias,
		}, { emitEvent: false });
		this.changeReference();
	}

	private applyOptionsFromService(options: OptionsReferenceDteEmitido): void {
		if (this.updatingFromThisComponent) {
			return;
		}
		if (!options) {
			return;
		}
		this.restoringFromDraft = true;
		const restoredOptions = Object.assign(new OptionsReferenceDteEmitido(), options ?? {});
		restoredOptions.listaReferencias = restoredOptions.listaReferencias ? restoredOptions.listaReferencias.map((ref) => Object.assign(new ReferenciaDteEmitido(), ref)) : undefined;
		this.optionsReference = restoredOptions;
		this.currentReferencesList = restoredOptions.listaReferencias ?? [];

		const tipoMoneda = restoredOptions.tipoMoneda ?? (this.currentInvoiceType == InvoiceType.FacturaExportacion ? "USD" : "CLP");
		const haveReference = this.requiereReferencia || !!restoredOptions.haveDteReference;
		this.optionsReferenceFormGroup.patchValue(
			{
				haveDteReference: haveReference,
				tipoMoneda,
				detallesExentos: restoredOptions.sonDetallesConIVA ?? false,
				dteReferenceList: restoredOptions.listaReferencias ?? [],
				dtePagado: restoredOptions.dtePagado ?? null,
			},
			{ emitEvent: false }
		);

		if (this.optionsReferenceFormGroup.contains("refGlobal")) {
			this.optionsReferenceFormGroup.controls.refGlobal.patchValue(restoredOptions.globalReferenceForGuideRefs ?? false, { emitEvent: false });
		}

		const isForeignCurrency = tipoMoneda === "USD" || tipoMoneda === "UF" || tipoMoneda === "OTHER";
		this.selectedForeignCurrency = isForeignCurrency;

		if (tipoMoneda === "OTHER" && restoredOptions.codigoMonedaAduana) {
			const moneda = this.monedasAduanaSource.find((item) => item.codigoAduana === restoredOptions.codigoMonedaAduana);
			this.optionsReferenceFormGroup.controls.tipoMonedaSelector.patchValue(moneda, { emitEvent: false });
		} else {
			this.optionsReferenceFormGroup.controls.tipoMonedaSelector.patchValue(undefined, { emitEvent: false });
		}

		const valorMoneda = isForeignCurrency ? (restoredOptions.valorTipoMoneda ?? 0) : 1;
		this.valorDivisaManual = isForeignCurrency && esTipoCambioValido(valorMoneda);
		this.divisasValueFormGroup.controls.newValorDivisa.patchValue(valorMoneda, { emitEvent: false });

		this.updateReferenceValidators(haveReference);

		if (this.referencesListComponent) {
			this.referencesListComponent.setReferencesFromDraft(restoredOptions.listaReferencias ?? []);
		} else {
			setTimeout(() => {
				this.referencesListComponent?.setReferencesFromDraft(restoredOptions.listaReferencias ?? []);
			});
		}

		this.restoringFromDraft = false;
		this.recalcDtePagadoAvailability();
		this.ref.detectChanges();
	}

	private updateReferenceValidators(haveReference: boolean): void {
		const control = this.optionsReferenceFormGroup.controls.dteReferenceList;
		if (haveReference || this.requiereReferencia) {
			control.setValidators([Validators.required]);
		} else {
			control.clearValidators();
		}
		control.updateValueAndValidity({ emitEvent: false });
	}
	private recalcDtePagadoAvailability(): void {
		const codigosPermitidos = [33, 34, 39, 41];
		const codigo = this.getCodigoDteEspecifico();

		const isValidByType =
			!!codigo &&
			codigosPermitidos.includes(codigo) &&
			this.tiposDteHabilitados.includes(codigo);

		this.canShowDtePagado = isValidByType;

		const canUseDtePagado = this.showDtePagadoButton && this.canShowDtePagado;

		const ctrl = this.optionsReferenceFormGroup?.get("dtePagado");
		if (!ctrl) return;

		let newModelValue: boolean | null = null;

		if (!canUseDtePagado) {
			newModelValue = null;
			ctrl.setValue(null, { emitEvent: false });
			ctrl.disable({ emitEvent: false });
		} else {
			ctrl.enable({ emitEvent: false });

			if (ctrl.value === null || ctrl.value === undefined) {
			ctrl.setValue(false, { emitEvent: false });
			}

			newModelValue = ctrl.value === true;
		}

		const prev = this.optionsReference.dtePagado;
		this.optionsReference.dtePagado = newModelValue;
		if (prev !== newModelValue && !this.restoringFromDraft) {
			this.updatingFromThisComponent = true;
			this.facturador.updateOptionsReferences(this.optionsReference);
			setTimeout(() => (this.updatingFromThisComponent = false));
		}
	}
}
